import React from 'react'

import Field from '../../Field/Field'
import FieldLabel from '../../FieldLabel/FieldLabel'
import TextInput from '../../TextInput/TextInput'
import ValidationMessage from '../../ValidationMessage/ValidationMessage'

import { getContentTypeFieldDataTestId, CONTENT_TYPE_FIELD_ACTION_IDS, generateMinMaxTestId } from '../helper'

const CustomUserLimit = ({ uniqueKey, schema, t, type, onchange }) => {

  const handleMaxInstanceChange = (event: any) => {
    schema['max_instance'] = parseInt(event.target.value)
    if (!schema.error_details) {
      schema.error_details = {}
    }
    if (event.target.value.length && (schema.max_instance < 0 || schema.max_instance === 0)) {
      if(schema.max_instance < 0){
        schema.error_details = {
          ...schema.error_details,
          max_instance: t('content_type.save_content_type.body.fields.common_properties.error_messages.min_max_limit.max_lt_zero') || 'Max limit cannot be less than 0.'
        }
      }
      if(schema.max_instance === 0){
        schema.error_details = {
          ...schema.error_details,
          max_instance: t('content_type.save_content_type.body.fields.common_properties.error_messages.min_max_limit.max_zero') || 'Max limit cannot be 0.'
        }
      }
    }
    else {
      schema.error_details = {
        ...schema.error_details,
        max_instance: ''
      }
    }
    if (schema.min_instance > 0) {
      if (schema.min_instance && schema.max_instance && schema.min_instance > schema.max_instance) {
        schema.error_details = {
          ...schema.error_details,
          min_instance: t('content_type.save_content_type.body.fields.common_properties.error_messages.min_max_limit.min_gt_max') || 'Min limit cannot exceed the max limit.'
        }
      }
      else {
        schema.error_details = {
          ...schema.error_details,
          min_instance: ''
        }
      }
    }
    if(schema.data_type === 'reference'){
      if (schema.max_instance > 0 && schema.field_metadata?.default_value?.length > schema.max_instance) {
        schema.error_details = {
          ...schema.error_details,
          default_value: `Default values exceed the maximum limit of ${schema.max_instance} entries.`
        }
      } else {
        schema.error_details = {
          ...schema.error_details,
          default_value: ''
        }
      }
    }
    schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
      ? true
      : false
  }

  const handleMinInstanceChange = (event: any) => {
    schema['min_instance'] = parseInt(event.target.value)
    if (!schema.error_details) {
      schema.error_details = {}
    }
    if (event.target.value.length && (schema.min_instance < 0 || schema.min_instance === 0)) {
      if(schema.min_instance < 0){
        schema.error_details = {
          ...schema.error_details,
          min_instance: t('content_type.save_content_type.body.fields.common_properties.error_messages.min_max_limit.min_lt_zero') || 'Min limit cannot be less than 0.'
        }
      }
      if(schema.min_instance === 0){
        schema.error_details = {
          ...schema.error_details,
          min_instance: t('content_type.save_content_type.body.fields.common_properties.error_messages.min_max_limit.min_zero') || 'Min limit cannot be 0.'
        }
      }
    }
    else if (schema.min_instance && schema.max_instance && schema.min_instance > schema.max_instance) {
      schema.error_details = {
        ...schema.error_details,
        min_instance: t('content_type.save_content_type.body.fields.common_properties.error_messages.min_max_limit.min_gt_max') || 'Min limit cannot exceed the max limit.'
      }
    }
    else {
      schema.error_details = {
        ...schema.error_details,
        min_instance: ''
      }
    }
    schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
      ? true
      : false
  }

  const onMaxInstance = (event: any) => {
    handleMaxInstanceChange(event)
    onchange()
  }

  const onMinInstance = (event: any) => {
    handleMinInstanceChange(event)
    onchange()
  }

  return (
    <>
      <div className='field-custom-limit flex-center'>
        <div className='Field--wrapper'>
          <Field>
            <FieldLabel testId="cs-form-field-custom-max-limit" version="v2" className="ml-8" htmlFor="validation">
            {t('content_type.save_content_type.body.fields.common_properties.labels.min_limit') || `Set Minimum Limit`}
            </FieldLabel>
            <TextInput
              type="number"
              version="v2"
              width="full"
              name={`${uniqueKey}.mininstance`}
              value={schema.min_instance || null}
              onChange={onMinInstance}
              // placeholder={t(
              //   'content_type.save_content_type.body.fields.common_properties.placeholders.minimum'
              // )}
              placeholder={t('content_type.save_content_type.body.fields.common_properties.placeholders.min_limit') || 'Enter the minimum limit'}
              error={schema.error && schema.min_instance && schema.error_details.min_instance ? true : false}
              testId={generateMinMaxTestId(schema, 'min')}
            />
            <div>
              {schema.error && schema.error_details && schema.error_details.min_instance ? (
                <ValidationMessage data-test-id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.MIN_MULTIPLE_CHOICE_LIMIT_INPUT_VALID)} version='v2' className='ml-8 error'>{schema.error_details.min_instance}</ValidationMessage>
              ) : <p className='nl-note-basic'>{t('content_type.save_content_type.body.fields.common_properties.help_text.min_limit') || 'Specify the minimum limit.'}</p>
              }
            </div>
          </Field>
        </div>
        <div className='divider flex-h-center'> - </div>
        <div className='Field--wrapper'>
          <Field>
            <FieldLabel testId="cs-form-field-custom-max-limit" version="v2" className="ml-8" htmlFor="validation">
            {t('content_type.save_content_type.body.fields.common_properties.labels.max_limit') || `Set Maximum Limit`}
            </FieldLabel>
            <TextInput
              type="number"
              version="v2"
              width="full"
              name={`${uniqueKey}.maxinstance`}
              value={schema.max_instance || null}
              onChange={onMaxInstance}
              // placeholder={t(
              //   'content_type.save_content_type.body.fields.common_properties.placeholders.maximum'
              // )}
              placeholder={t('content_type.save_content_type.body.fields.common_properties.placeholders.max_limit') || 'Enter the maximum limit'}
              error={schema.error && schema.max_instance && schema.error_details.max_instance ? true : false}
              testId={generateMinMaxTestId(schema, 'max')}
            />
            <div>
              {schema.error && schema.error_details && schema.error_details.max_instance ? (
                <ValidationMessage data-test-id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.MAX_MULTIPLE_CHOICE_LIMIT_INPUT_VALID)} version='v2' className='ml-8 error'>{schema.error_details.max_instance}</ValidationMessage>
              ) : <p className='nl-note-basic'>{t('content_type.save_content_type.body.fields.common_properties.help_text.max_limit') || 'Specify the maximum limit.'}</p>}
            </div>
          </Field>
        </div>
      </div>
    </>
  )
}

export default CustomUserLimit
